import { Stack, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { ConfigItemsLayout } from "./ConfigItemsLayout";
import { AlignStartVerticalIcon, Button, DownloadIcon } from "components";
export const PositionConfigItem = ({ isLoading }: { isLoading: boolean }) => {
  const { watch, setValue } = useFormContext();
  const position = watch("position");
  const theme = useTheme();

  const positions = [
    {
      value: "left",
      icon: (
        <DownloadIcon
          sx={{
            width: 24,
            height: 24,
            transform: "rotate(90deg)",
          }}
          htmlColor={theme.palette.lightBg.high}
        />
      ),
    },
    {
      value: "right",
      icon: (
        <DownloadIcon
          sx={{
            width: 24,
            height: 24,
            transform: "rotate(-90deg)",
          }}
          htmlColor={theme.palette.lightBg.high}
        />
      ),
    },
    {
      value: "top",
      icon: (
        <DownloadIcon
          sx={{
            width: 24,
            height: 24,
            transform: "rotate(180deg)",
          }}
          htmlColor={theme.palette.lightBg.high}
        />
      ),
    },
    {
      value: "bottom",
      icon: (
        <DownloadIcon
          sx={{
            width: 24,
            height: 24,
          }}
          htmlColor={theme.palette.lightBg.high}
        />
      ),
    },
  ];
  return (
    <ConfigItemsLayout
      title="Position"
      description="Control where your logo will be displayed 
  alongside your text."
      icon={<AlignStartVerticalIcon sx={{ width: 20, height: 20 }} />}
    >
      <Stack
        direction={"row"}
        sx={{
          gap: "4px",
          border: `1px solid ${theme.palette.neutral["010"]}`,
          borderRadius: "8px",
          p: "4px 6px",
          height: "fit-content",
        }}
      >
        {positions.map((item) => (
          <Button
            key={item.value}
            variant="ghost"
            icon={item.icon}
            disabled={isLoading}
            sx={{
              bgcolor:
                item.value === position
                  ? theme.palette.neutral["005"]
                  : "transparent",
              borderRadius: "4px",
            }}
            isIconOnly
            onClick={() => {
              if (!isLoading) {
                setValue("position", item.value, {
                  shouldDirty: true,
                });
              }
            }}
          ></Button>
        ))}
      </Stack>
    </ConfigItemsLayout>
  );
};
